const isLocal = process.env.NODE_ENV === 'development';

const API_BASE_URL = isLocal
  ? 'http://localhost:5000'
  : 'https://api.dogfanciersguild.com';

export default API_BASE_URL;